import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import {AuthService} from '../services/infrastructure/auth.service';

export const guestGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  // Se NÃO estiver autenticado, pode acessar o login
  if (!authService.isAuthenticated()) {
    return true;
  }

  // Se JÁ estiver logado, chuta para a dashboard/home
  router.navigate(['/']);
  return false;
};
